import { render, staticRenderFns } from "./LoginWXgo.vue?vue&type=template&id=fb7fd302&"
import script from "./LoginWXgo.vue?vue&type=script&lang=js&"
export * from "./LoginWXgo.vue?vue&type=script&lang=js&"
import style0 from "./LoginWXgo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports